import React, { useRef, useState, useEffect } from 'react'

interface TruncatedCellProps {
  text: string
  className?: string
  maxWidth?: number
}

export const TruncatedCell: React.FC<TruncatedCellProps> = ({
  text,
  className = '',
  maxWidth = 200,
}) => {
  const textRef = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(
          textRef.current.scrollWidth > textRef.current.clientWidth,
        )
      }
    }

    checkTruncation()
    window.addEventListener('resize', checkTruncation)

    return () => window.removeEventListener('resize', checkTruncation)
  }, [text])

  return (
    <div
      className="relative"
      onMouseEnter={() => isTruncated && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div
        ref={textRef}
        className={`truncate ${className}`}
        style={{ maxWidth }}
      >
        {text}
      </div>

      {showTooltip && (
        <div
          className="absolute z-50 px-3 py-2 text-sm bg-gray-900 text-white rounded-lg shadow-lg whitespace-normal break-words"
          style={{
            bottom: '100%',
            left: 0,
            marginBottom: '4px',
            maxWidth: '300px',
          }}
        >
          {text}
          <div
            className="absolute w-2 h-2 bg-gray-900 transform rotate-45"
            style={{
              bottom: '-4px',
              left: '12px',
            }}
          />
        </div>
      )}
    </div>
  )
}
